const termsPage = `plus_termspage(uid: "bltbfc82c1eadc45e57") {
    subtitle
    text
    title
}`;

export default termsPage;
